import React from 'react';
import PropTypes from 'prop-types';
import './Loader.scss';

const Loader = (props) => {
  const { percent } = props;

  return (
    <div className="uploader-loader animated fadeIn">
      <span className="uploader-loader__title font-12">
        Loading...
      </span>
      <div className="uploader-loader__progress progress">
        <div
          aria-label="progressbar"
          className="uploader-loader__progress__bar progress-bar"
          role="progressbar"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

Loader.propTypes = {
  percent: PropTypes.number,

};

Loader.defaultProps = {
  percent: 0,
};

export default Loader;
